export const items = [
  {
    id: 1,
    name: 'HP Gas Cylinder',
    sku: 'CYL001',
    type: 'Goods',
    description: 'Domestic LPG Cylinder',
    purchaseDescription: 'Purchase from Bharat Gas',
    costPrice: 950,
    sellingPrice: 1100,
    account: 'Sales',
    preferredVendor: 'HP Gas',
    purchaseAccount: 'Cost Of Goods',
    unit: 'Nos',
    stock: 25,
  },
  {
    id: 2,
    name: 'Regulator',
    sku: 'REG001',
    type: 'Goods',
    description: 'Gas Regulator',
    purchaseDescription: 'Standard Regulator',
    costPrice: 450,
    sellingPrice: 650,
    account: 'Sales',
    preferredVendor: 'Surya Gas',
    purchaseAccount: 'Inventory',
    unit: 'Piece',
    stock: 45,
  },
  {
    id: 3,
    name: 'Hose Pipe',
    sku: 'HOS001',
    type: 'Goods',
    description: 'Flexible Rubber Pipe',
    purchaseDescription: 'Rubber Pipe',
    costPrice: 150,
    sellingPrice: 250,
    account: 'Sales',
    preferredVendor: 'Aqua Gas',
    purchaseAccount: 'Inventory',
    unit: 'Meter',
    stock: 60,
  },
  {
    id: 4,
    name: 'Valve',
    sku: 'VAL001',
    type: 'Goods',
    description: 'Safety Valve',
    purchaseDescription: 'Brass Valve',
    costPrice: 220,
    sellingPrice: 350,
    account: 'Sales',
    preferredVendor: 'Prime Supplies',
    purchaseAccount: 'Inventory',
    unit: 'Piece',
    stock: 40,
  },
  {
    id: 5,
    name: 'Commercial Cylinder',
    sku: 'CYL002',
    type: 'Goods',
    description: '19Kg Cylinder',
    purchaseDescription: 'Industrial Gas',
    costPrice: 1800,
    sellingPrice: 2200,
    account: 'Sales',
    preferredVendor: 'HP Gas',
    purchaseAccount: 'Cost Of Goods',
    unit: 'Nos',
    stock: 18,
  },
];

export const getItems = () => {
  if (typeof window === 'undefined') {
    return items;
  }

  try {
    const stored = window.localStorage.getItem('zoho-items');
    return stored ? JSON.parse(stored) : items;
  } catch (error) {
    return items;
  }
};

export const saveItems = (nextItems) => {
  if (typeof window !== 'undefined') {
    window.localStorage.setItem('zoho-items', JSON.stringify(nextItems));
  }
  return nextItems;
};
